module.exports = __webpack_public_path__ + "img/IT0000104748984.dacd46bd.png";